import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetUserProfileResponseType } from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

interface UseGetUserProfileAPIInterface {
  getUserProfileDataApi: UseMutateAsyncFunction<
    GetUserProfileResponseType,
    unknown,
    void,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useGetUserProfileAPI = (): UseGetUserProfileAPIInterface => {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getUserProfileData = () => {
    return ibUserAccountsAPIService.getUserProfileData();
  };

  const { mutateAsync, error, status } = useMutation(getUserProfileData, {
    mutationKey: ['getUserProfileDataApi']
  });

  return {
    getUserProfileDataApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetUserProfileAPI };
